// JsFromRoutes CacheKey d3ad70e74b301cad8ee4953a23b75fc4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_modules/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_modules/:id/duplicate'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/category_modules/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/category_modules'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_modules'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/category_modules/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/category_modules/:id'),
}
